export const PUSH_NOTIFICATIONS_PROMPT_TYPES = {
    LOYALTY_CLICK: 'LOYALTY_CLICK',
    AUTODELIVERY_DASHBOARD_CLICK: 'AUTODELIVERY_DASHBOARD_CLICK',
    URL_OPEN_ON_SHOP_PAGE: 'URL_OPEN_ON_SHOP_PAGE',
    REGULAR: 'REGULAR',
};

export const getEventNameByPromptType = (promptType) => {
    switch (promptType) {
        case PUSH_NOTIFICATIONS_PROMPT_TYPES.LOYALTY_CLICK:
            return 'Loyalty';
        case PUSH_NOTIFICATIONS_PROMPT_TYPES.AUTODELIVERY_DASHBOARD_CLICK:
            return 'Autodelivery';
        case PUSH_NOTIFICATIONS_PROMPT_TYPES.URL_OPEN_ON_SHOP_PAGE:
            return 'Shop';
        case PUSH_NOTIFICATIONS_PROMPT_TYPES.REGULAR:
            return 'Regular use';
        default:
            return '';
    }
};
